import { Injectable, OnDestroy } from '@angular/core';
import { PlycaDataService } from '../../services/plyca.service';
import { Observable } from 'rxjs';
import { AppState } from '../store/AppState';
import { Store } from '@ngrx/store';
import { Configuration } from '../conf/app.constants';
import { CompanyDTO } from '../api/plyca-dtos-v2';
import { PropertyService } from '../properties/property.service';
import { tap, finalize, catchError, map } from 'rxjs/operators';
import { forkJoin, of, throwError } from 'rxjs';
import { BaseDirectiveObject } from '../components/common/base-directive-object';


@Injectable({ providedIn: 'root' })
export class CompanyService extends BaseDirectiveObject implements OnDestroy {

  public ADD_MODE = 'Update';
  public EDIT_MODE = 'Insert';
  public locale: string;
  private companyIntegrationProperties = {};

  constructor(
    private plycaService: PlycaDataService,
    protected store: Store<AppState>,
    protected configuration: Configuration,
    private propertyService: PropertyService
  ) {
    super();
    this.subscribe(
      forkJoin([
        // com.nexusit.integraciones.terceros.logica.ConstantesIntegracionTerceros
        //SincronizacionTercerosActivo = "SincronizacionTerceros.Activo"
        //SincronizacionTercerosFraMtoEmpresaPublicarAlCrearTerceroActivo = "SincronizacionTerceros.FraMtoEmpresa.PublicarAlCrearTercero.Activo";
        //SincronizacionTercerosFraMtoEmpresaPublicarAlModificarTerceroActivo = "SincronizacionTerceros.FraMtoEmpresa.PublicarAlModificarTercero.Activo";
        //String SincronizacionTercerosFraMtoEmpresaPublicarAlEliminarTerceroActivo = "SincronizacionTerceros.FraMtoEmpresa.PublicarAlEliminarTercero.Activo";
        this.propertyService.getProperty('SincronizacionTerceros.Activo', '0')
          .pipe(catchError((error: any) => {
            console.log(error)
            return of(undefined)
          }))
        ,
        this.propertyService.getProperty('SincronizacionTerceros.FraMtoEmpresa.PublicarAlCrearTercero.Activo', '0')
          .pipe(catchError((error: any) => {
            console.log(error)
            return of(undefined)
          }))
        ,
        this.propertyService.getProperty('SincronizacionTerceros.FraMtoEmpresa.PublicarAlModificarTercero.Activo', '0')
          .pipe(catchError((error: any) => {
            console.log(error)
            return of(undefined)
          }))
        ,
        this.propertyService.getProperty('SincronizacionTerceros.FraMtoEmpresa.PublicarAlEliminarTercero.Activo', '0')
          .pipe(catchError((error: any) => {
            console.log(error)
            return of(undefined)
          }))

      ]).pipe(
        map(
          (prop: any[]) => {
            this.companyIntegrationProperties['SincronizacionTerceros_Activo'] = prop[0] == '1';
            this.companyIntegrationProperties['SincronizacionTerceros_FraMtoEmpresa_PublicarAlCrearTercero_Activo'] = prop[1] == '1';
            this.companyIntegrationProperties['SincronizacionTerceros_FraMtoEmpresa_PublicarAlModificarTercero_Activo'] = prop[2] == '1';
            this.companyIntegrationProperties['SincronizacionTerceros_FraMtoEmpresa_PublicarAlEliminarTercero_Activo'] = prop[3] == '1';
          }),
        finalize(() => {

        })
      )
    )

  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  /*search(searchText: string): Observable<any> {

    return this.plycaService.query<any>(
      this.configuration.HELP_ELEMENT_SERVICE_URL,
      {
        locale: this.translate.currentLang,
        search: searchText
      }
    );
  }*/

  save(company: CompanyDTO): Observable<any> {
    console.log('company', company);
    let mode: string = this.ADD_MODE;
    if (company && company.identifier != null) {
      mode = this.EDIT_MODE
    }
    if (company != null
      && company.identifier != null) {
      return this.update(company);
    } else {
      return this.insert(company);
    }
  }

  insert(row: CompanyDTO): Observable<any> {
    console.log('ComapnyDTO', row);
    return this.plycaService
      .insert<CompanyDTO>(
        this.configuration.COMPANY_SERVICE_URL,
        row
      );
  }

  update(row: CompanyDTO): Observable<any> {
    console.log('ComapnyDTO', row);
    return this.plycaService
      .update<CompanyDTO>(
        this.configuration.COMPANY_SERVICE_URL,
        row
      );
  }

  get(row: CompanyDTO): Observable<any> {
    return this.plycaService
      .get<CompanyDTO>(
        this.configuration.COMPANY_SERVICE_URL, row.identifier
      );

  }

  remove(row: CompanyDTO): Observable<any> {
    return this.plycaService.delete(this.configuration.COMPANY_SERVICE_URL, row.identifier);

  }

  viewModel2DTO(companyDto: CompanyDTO) {

    let data: Array<any> = [];
    let pymeValue: boolean;
    try {
      pymeValue = companyDto.ext.pyme.value;
    } catch (w) { }

    let hiddenStructureValue: boolean;
    try {
      hiddenStructureValue = companyDto.ext.hiddenStructure.value;
    } catch (w) { }

    let specialJobValue: boolean;
    try {
      specialJobValue = companyDto.ext.specialJob.value;
    } catch (w) { }

    if (pymeValue != null) {
      let pyme = { 'name': 'EMP_ES_PYME_STD', 'description': 'EMP_ES_PYME_STD', 'type': 'String', 'value': pymeValue ? '1' : '0' };
      data.push(pyme);
    }

    if (hiddenStructureValue != null) {
      let hiddenStructure = {
        'name': 'EMP_TIENE_ESTRC_PROP_OCULTA_STD',
        'description': 'EMP_ES_PYME_STD',
        'type': 'String',
        'value': hiddenStructureValue ? '1' : '0'
      };
      data.push(hiddenStructure);
    }

    if (specialJobValue != null) {
      let specialJob = { 'name': 'EMP_ESP_EMPLEO_INSER_STD', 'description': 'EMP_ES_PYME_STD', 'type': 'String', 'value': specialJobValue ? '1' : '0' };
      data.push(specialJob);
    }

    companyDto.data = data;
    companyDto['externalIdentifierTempDescription'] = null;
    companyDto['companyIntegrationProperties'] = null;

    console.log('viewModel2DTO //////////////////////////// data', data);
  }

  dto2ViewModel(companyDto: CompanyDTO) {
    if (companyDto && companyDto.data) {
      let ext: any = {};
      companyDto.data.forEach(el => {
        if (el.name === 'EMP_ES_PYME_STD') {
          ext.pyme = {};
          ext.pyme.name = el.name;
          ext.pyme.value = el.value === '1' ? true : false;
        } else if (el.name === 'EMP_TIENE_ESTRC_PROP_OCULTA_STD') {
          ext.hiddenStructure = {};
          ext.hiddenStructure.name = el.name;
          ext.hiddenStructure.value = el.value === '1' ? true : false;
        } else if (el.name === 'EMP_ESP_EMPLEO_INSER_STD') {
          ext.specialJob = {};
          ext.specialJob.name = el.name;
          ext.specialJob.value = el.value === '1' ? true : false;
        } else {
          console.log('Atributo extendiudo no tratado');
        }
      });
      companyDto.ext = ext;
    } else if (companyDto) {
      if (this.companyIntegrationProperties) {
        companyDto['companyIntegrationProperties'] = this.companyIntegrationProperties;
        if (this.companyIntegrationProperties['SincronizacionTerceros_Activo']) {
          if (companyDto.externalIdentifier) {
            companyDto['externalIdentifierTempDescription'] = 'Sí. ID=' + companyDto.externalIdentifier;
          } else {
            companyDto['externalIdentifierTempDescription'] = 'No';
          }
        }
      }
    }
  }
}
